import * as Actions from '../../actions/index';

const initialState = {
    state  : false,
    options: {
        children: 'CC'
    }
};

const modal = function (state = initialState, action) {
    switch ( action.type )
    {
        case Actions.OPEN_MODAL:
        {
            return {
                ...state,
                state  : true,
                options: {
                    ...state.options,
                    ...action.options
                }
            };
        }
        case Actions.CLOSE_MODAL:
        {
            return {
                ...state,
                state: false
            };
        }
        default:
        {
            return state;
        }
    }
};

export default modal;
